import React from "react";

//ASSETS
import LeftArrowIcon from "assets/icons/ArrowDatePicker.svg";

// STYLES
import {
  DatePickerContainer,
  Day,
  DaysContainer,
  Header,
  HorizontalLine,
  LeftArrow,
  Month,
  MonthWrapper,
  MonthsContainer,
  RightArrow,
  VerticalLine,
  YearContainer,
  YearWrapper,
} from "./DatePickerStyled";

// LIBRARIES

// MISC
import { TextType } from "components/Atoms/CustomText/CustomTextModel";
import { COLORS } from "constants/variables";
import useWindowWidth from "hooks/useWindowWidth";
import { DatePickerProps, months } from "./DatePickerModel";

// REDUX

import { useSelector } from "react-redux";
import { accessibilityBiggerCursorSelector } from "slices/UISlice/uiSliceSelectors";

// COMPONENTS
import CustomText from "components/Atoms/CustomText/CustomText";

// CONFIGURATION

const DatePicker: React.FC<DatePickerProps> = (props: DatePickerProps) => {
  // PROPERTIES
  const {
    selectedYear,
    setSelectedYear,
    selectedMonth,
    setSelectedMonth,
    selectedDay,
    setSelectedDay,
  } = props;

  //LIBRARY

  const biggerCursor = useSelector(accessibilityBiggerCursorSelector);

  // STATE CONSTANTS
  const daysInMonth = new Date(selectedYear, selectedMonth + 1, 0).getDate();
  const windowWidth = useWindowWidth();

  // EVENT HANDLERS
  const handleYearChange = (increment: number) => {
    setSelectedYear(selectedYear + increment);
  };

  const handleMonthChange = (increment: number) => {
    if (selectedMonth + increment > 11) {
      setSelectedMonth(0);
      setSelectedYear(selectedYear + 1);
    } else if (selectedMonth + increment < 1) {
      setSelectedMonth(12);
      setSelectedYear(selectedYear - 1);
    } else {
      setSelectedMonth(selectedMonth + increment);
    }
  };

  const handleMonthSelect = (index: number) => {
    setSelectedMonth(index);
  };

  const handleDaySelect = (day: number) => {
    setSelectedDay(day);
  };

  return (
    <DatePickerContainer>
      <Header>
        <YearContainer>
          {windowWidth < 1300 && (
            <LeftArrow
              src={LeftArrowIcon}
              alt="arrow"
              onClick={() => handleYearChange(-1)}
              biggerCursor={biggerCursor}
            />
          )}
          <YearWrapper>
            <CustomText
              type={TextType.H3regular}
              text={selectedYear}
              color={COLORS.RaisinBlack}
            />
          </YearWrapper>

          {windowWidth >= 1300 && (
            <LeftArrow
              src={LeftArrowIcon}
              alt="arrow"
              onClick={() => handleYearChange(-1)}
              biggerCursor={biggerCursor}
            />
          )}
          <RightArrow
            src={LeftArrowIcon}
            alt="arrow"
            onClick={() => handleYearChange(1)}
            biggerCursor={biggerCursor}
          />
        </YearContainer>
        { <VerticalLine />}
        {windowWidth < 450 ? (
          <YearContainer>
            <LeftArrow
              src={LeftArrowIcon}
              alt="arrow"
              onClick={() => handleMonthChange(-1)}
              biggerCursor={biggerCursor}
            />
            <MonthWrapper>
              <CustomText
                type={TextType.H3regular}
                text={months[selectedMonth]}
                color={COLORS.RaisinBlack}
              />
            </MonthWrapper>
            <RightArrow
              src={LeftArrowIcon}
              alt="arrow"
              onClick={() => handleMonthChange(1)}
              biggerCursor={biggerCursor}
            />
          </YearContainer>
        ) : (
          <MonthsContainer>
            {months.map((month, index) => (
              <Month
                key={month}
                selected={index === selectedMonth}
                onClick={() => handleMonthSelect(index)}
                biggerCursor={biggerCursor}
              >
                <CustomText
                  type={TextType.P1}
                  text={month}
                  color={
                    index === selectedMonth
                      ? COLORS.Cultured
                      : COLORS.MetalicSilver
                  }
                />
              </Month>
            ))}
          </MonthsContainer>
        )}
      </Header>
      <HorizontalLine />
      <DaysContainer>
        {[...Array(daysInMonth)].map((_, index) => {
          const day = index + 1;
          const date = new Date(selectedYear, selectedMonth, day);
          const dayOfWeek = date.getDay(); // 0 is Sunday, 1 is Monday, ..., 6 is Saturday
          const isWorkingDay = dayOfWeek >= 1 && dayOfWeek <= 5; // Monday to Friday are working days
          
          return (
            <Day
              key={index}
              selected={day === selectedDay}
              workingDay={isWorkingDay}
              onClick={() => handleDaySelect(day)}
              biggerCursor={biggerCursor}
            >
              <CustomText
                className="custom-text"
                type={isWorkingDay ? TextType.P2 : TextType.P1}
                text={day}
                color={
                  day === selectedDay
                    ? COLORS.Cultured
                    : isWorkingDay
                    ? COLORS.RaisinBlack
                    : COLORS.MetalicSilver
                }
              />
            </Day>
          );
        })}
      </DaysContainer>
    </DatePickerContainer>
  );
};

export default DatePicker;
